import { Logout as LogoutIcon, PhotoCamera } from "@mui/icons-material";
import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

interface HeaderProps {
  title?: string;
}

const Header: React.FC<HeaderProps> = ({ title = "Photo Admin Portal" }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <AppBar position="static" elevation={1}>
      <Toolbar
        sx={{ justifyContent: "space-between", px: { xs: 2, sm: 4, md: 6 } }}
      >
        <Button
          color="inherit"
          onClick={() => {
            navigate("/dashboard");
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              flexGrow: 1,
            }}
          >
            {/* Logo container with white background */}
            <Box
              sx={{
                width: 48,
                height: 32,
                backgroundColor: "white",
                borderRadius: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.1)",
              }}
            >
              <PhotoCamera
                sx={{
                  width: 24,
                  height: 18,
                  color: "primary.main",
                }}
              />
            </Box>

            {/* App title */}
            <Typography
              variant="h6"
              component="h1"
              sx={{
                fontWeight: 600,
                fontSize: "1.125rem",
                color: "white",
                letterSpacing: "0.025em",
              }}
            >
              {title}
            </Typography>
          </Box>
        </Button>

        {/* Logout button on RHS */}
        <Button
          color="inherit"
          onClick={handleLogout}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            textTransform: "none",
            fontSize: "0.95rem",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
        >
          <LogoutIcon sx={{ width: 20, height: 20 }} />
          <Typography sx={{ display: { xs: "none", sm: "block" } }}>
            Logout
          </Typography>
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
